import { getSupabase } from './client';
import type { Json } from './database.types';

export type ClientErrorKind = 'error' | 'unhandledrejection' | 'manual';

export interface ClientErrorInput {
  readonly kind: ClientErrorKind;
  readonly message: string;
  readonly stack?: string | null;
  readonly context?: Json;
}

function clip(value: string | null | undefined, max: number): string | null {
  if (!value) return null;
  return value.length > max ? `${value.slice(0, max)}…` : value;
}

/**
 * Best-effort error report into public.client_errors (the no-third-party-account
 * APM alternative — see 20261008030000_client_error_log.sql). Never throws: a
 * failed report must not itself become a second error.
 */
export async function reportClientError(
  workspaceId: string,
  appKey: string,
  actorEmail: string | null,
  input: ClientErrorInput,
): Promise<void> {
  try {
    const { error } = await getSupabase()
      .from('client_errors')
      .insert({
        workspace_id: workspaceId,
        app_key: appKey,
        actor_email: actorEmail,
        kind: input.kind,
        message: clip(input.message, 2000) ?? '(empty message)',
        stack: clip(input.stack ?? null, 8000),
        url: clip(window.location.href, 500),
        user_agent: clip(navigator.userAgent, 300),
        context: input.context ?? null,
      });
    if (error) console.warn('[client-error-log] report failed', error);
  } catch (err: unknown) {
    console.warn('[client-error-log] report threw', err);
  }
}
